import React from 'react'

import { useRouter } from './Router'

type HtmlAnchorProps = JSX.IntrinsicElements['a']
export interface RouterLinkProps extends HtmlAnchorProps {
  to: string
}

export function RouterLink({ to, onClick, ...rest }: RouterLinkProps) {
  const { navigator } = useRouter()
  return (
    <a
      {...rest}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        navigator.navigate(to)
        if (onClick) {
          onClick(e)
        }
      }}
      href={to}
    />
  )
}
